import { createFileRoute } from '@tanstack/react-router';
import { CompanyChainsList } from '@/app/(client)/supply-chain-mapping/-components/CompanyChainsList';

export const Route = createFileRoute(
  '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/archive/',
)({
  component: ArchiveSupplyChainsPage,
});

function ArchiveSupplyChainsPage() {
  return <CompanyChainsList isArchived={true} />;
}
